import React, { useEffect, useState } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import moment from 'moment'

import useFetchData from 'Shared/Hooks/useFetchData'
import DataTable from 'Shared/Components/DataTable'
import { apiUrl } from 'Shared/utils'
import useLoop from 'Shared/Hooks/useLoop'

const FloodData = () => {
  const { role, setPageLoading } = useOutletContext()
  const { t } = useTranslation()
  const { send } = useFetchData()
  const navigate = useNavigate()

  const [floodData, setFloodData] = useState([])

  const getLatestData = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/flood_sensor/data`,
      returnType: "json"
    })

    body && setFloodData(body.map((i) => ({
      "id": i["device_id"],
      "device_name": i["device_name"],
      "battery_level": (i["battery_level"] != null) ? <div>{i["battery_level"]} %</div> : null,
      "wetness_level": (i["wetness_level"] != null) ? <div className={i["flooding_status"] ? 'text-alert' : "text-normal"}>{i["flooding_status"] ? 'Alert' : "Normal"}</div> : null,
      "last_update": (i["last_update"] != null) ? moment(i["last_update"]).format("YYYY-MM-DD HH:mm:ss") : null
    })))
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await Promise.all([
        getLatestData()
      ])

      setPageLoading(false)
    }

    init()
  }, [])
  
  useLoop(getLatestData, 30000)

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={floodData} count={null}
              // onRowClick={(["pm", "so", "admin"].includes(role)) && function(e, row) { navigate(`./${row["id"]}`) }}
              columns={{
                "device_name": { "label": t("general_deviceName"), "sorting": false, "nowrap": true },
                "battery_level": { "label": t("floodingSensor_batteryLevel"), "sorting": false, "nowrap": true },
                "wetness_level": { "label": t("floodingSensor_wetnessLevel"), "sorting": false, "nowrap": true },
                "last_update": { "label": t("general_lastUpdate"), "sorting": false, "nowrap": true },
              }}
            />
          </Paper>
        </Col>
      </Row>
    </Container>
  </>)
}

export default FloodData